import styled from 'styled-components'

import { ChangeEvent } from 'react'
import Toggle from './toggle'

const Container = styled.div`
  width: 400px;
  height: 80px;
  padding: 4px 16px;
  border: 1px solid #e0e0e0;
  border-radius: ${(p) => p.theme.space.s};
  background-color: #ffffff;
  box-sizing: border-box;
  display: flex;
  margin-bottom: 16px;

  @media only screen and (max-width: ${(p) => p.theme.vp}px) {
    width: 100%;
    max-width: 400px;
    height: 60px;
    padding: 4px 12px;
  }
`

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${(p) => p.theme.FONT_COLOR};
  width: 100%;

  @media only screen and (max-width: ${(p) => p.theme.vp}px) {
    gap: 8px;
  }
`

const NameLabel = styled.label`
  font-size: ${(p) => p.theme.font.size.m};
  font-weight: 500;
  line-height: 1.5;
  cursor: pointer;

  @media only screen and (max-width: ${(p) => p.theme.vp}px) {
    font-size: 13px;
  }
`

const SettingToggle = (props: {
  labelName: string
  targetKey: string
  value: boolean
  onChange: (key: string, value: boolean) => void
}) => {
  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    props.onChange(props.targetKey, e.target.checked)
  }

  return (
    <Container>
      <Wrapper>
        <NameLabel>{props.labelName}</NameLabel>
        <Toggle defaultChecked={props.value} onChange={onChange} />
      </Wrapper>
    </Container>
  )
}

export default SettingToggle
